"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionCheckValidation = void 0;
const Field_Constant_1 = require("./Field.Constant");
const Field_Function_1 = require("../utils/Field.Function");
const type_1 = require("../../../type");
const FunctionCheckValidation = (mode, language, modelError = [], name = "", value = "", type = "", errorCustoms = false, listener, label = "", errorName = "") => {
    if (name) {
        let temp = [];
        modelError.forEach((key) => {
            if (key === type_1.TYPE_MODEL_ERROR_REQURIED) {
                temp.push((0, Field_Function_1.FunctionCheckIsRequired)(value, Field_Constant_1.ERROR_MESSAGE_REQUIRED[language]));
            }
            else if (key === type_1.TYPE_MODEL_ERROR_NUMBER) {
                temp.push((0, Field_Function_1.FunctionCheckIsNumber)(value, Field_Constant_1.ERROR_MESSAGE_NUMBER[language], Field_Constant_1.ERROR_MESSAGE_MINUS[language]));
            }
            else if (key === type_1.TYPE_MODEL_ERROR_EMAIL) {
                temp.push((0, Field_Function_1.FunctionCheckEmail)(value, Field_Constant_1.ERROR_MESSAGE_EMAIL[language]));
            }
            else if ((key === null || key === void 0 ? void 0 : key.split(":")[0]) === type_1.TYPE_MODEL_ERROR_LIMIT) {
                const limit = Number(key === null || key === void 0 ? void 0 : key.split(":")[1]);
                temp.push((0, Field_Function_1.FunctionCheckLimit)(type === type_1.TYPE_NUMBER ? Number(value) : value, limit, type === type_1.TYPE_NUMBER
                    ? Field_Constant_1.ERROR_MESSAGE_LIMIT_NUMBER[language].replace("{value}", limit)
                    : Field_Constant_1.ERROR_MESSAGE_LIMIT_STRING[language].replace("{value}", limit)));
            }
            else if ((key === null || key === void 0 ? void 0 : key.split(":")[0]) === type_1.TYPE_MODEL_ERROR_MINIMUM) {
                const minimum = Number(key === null || key === void 0 ? void 0 : key.split(":")[1]);
                temp.push((0, Field_Function_1.FunctionCheckMinimum)(type === type_1.TYPE_NUMBER ? Number(value) : value, minimum, type === type_1.TYPE_NUMBER
                    ? Field_Constant_1.ERROR_MESSAGE_MINIMUM_NUMBER[language].replace("{value}", minimum)
                    : Field_Constant_1.ERROR_MESSAGE_MINIMUM_STRING[language].replace("{value}", minimum)));
            }
            else if (key === type_1.TYPE_MODEL_ERROR_NO_SPACE) {
                temp.push((0, Field_Function_1.FunctionCheckNoSpace)(value, Field_Constant_1.ERROR_MESSAGE_NO_SPACE[language]));
            }
            else if (key === type_1.TYPE_MODEL_ERROR_NO_SPECIAL_CHARACTER) {
                temp.push((0, Field_Function_1.FunctionCheckNoSpacialCharacter)(value, Field_Constant_1.ERROR_MESSAGE_NO_SPECIAL_CHARATER[language]));
            }
        });
        if (errorCustoms) {
            temp.push(errorCustoms({ value, name, listener }));
        }
        const error_message = temp.filter((err) => {
            return err !== "";
        });
        if (error_message[0] === Field_Constant_1.ERROR_MESSAGE_REQUIRED[language]) {
            return {
                error: true,
                message: Field_Constant_1.ERROR_MESSAGE_REQUIRED[language],
                value: value,
                field_name: name,
                label: label,
                error_name: errorName,
            };
        }
        else if (error_message.length === 1) {
            return {
                error: true,
                message: String(error_message),
                value: value,
                field_name: name,
                label: label,
                error_name: errorName,
            };
        }
        else if (error_message.length > 1) {
            return {
                error: true,
                message: error_message.join(","),
                value: value,
                field_name: name,
                label: label,
                error_name: errorName,
            };
        }
        else {
            const formatValue = type === type_1.TYPE_NUMBER || type === type_1.TYPE_CALCULATOR
                ? Number(value) || 0
                : value || "";
            return mode === type_1.TYPE_MODE_NORMAL
                ? formatValue
                : {
                    error: false,
                    message: "",
                    field_name: name,
                    value: formatValue,
                    label: label,
                    error_name: errorName,
                };
        }
    }
    else {
        return { error: false, message: "" };
    }
};
exports.FunctionCheckValidation = FunctionCheckValidation;
